
function brands() {

	let $country = $("#country");
	let $region = $("#region");
	let $reset = $("#show_all");
	let $tiles = $(".brand-tiles__tile");
	let $options = $("option");

	$reset.on("click", function (e) {
		e.preventDefault;
		// reset the region selector
		$region.val("")
		$country.val("").trigger("change");
		$(".hide").removeClass("hide");
	});

	$country.on("change", function () {
		// reset region options on every change
		$options.removeClass("hide");
		// set region selector to this country
		let country = $(this).val();
		if (country) {
			let selector = `[data-country!='${country}']`;
			$(selector, $region).addClass("hide");
		}
		// always have the default region option
		$(":first-child", $region).removeClass("hide");

		if (country) {
			let $targets = $(".country--" + country);
			$targets.removeClass("hide");
			$tiles.not($targets).addClass("hide");
		}
		else {
			$tiles.removeClass("hide");
		}

	});
	$region.on("change", function () {

		// show the right tiles
		let region = $(this).val();
		if (region) {
			// set country selector to this regions country
			let country = $(":selected", this).data("country");
			$country.val(country);
			let $targets = $(".region--" + region);
			$targets.removeClass("hide");
			$tiles.not($targets).addClass("hide");
		}
		else {
			$(this).prev().trigger("change");
			// $tiles.removeClass("hide");
		}
	});
}



export function init() {
	// if not brands page, exit
	if (!$(".t_brands").length) return;

	brands();
}
